export default __webpack_public_path__ + "static/media/row-md.fed81c41.svg";